export default "__VITE_ASSET__2DgxBcl3__"